/* eslint-disable array-callback-return */
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const setCookies = (key, value) => {
  cookies.set(key, value, {
    path: "/",
    expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
  });
};

export const getCookies = (key) => {
  return cookies.get(key);
};

export const deleteCookies = (key) => {
  cookies.remove(key);
};

export const getAllCookies = () => {
  return cookies.getAll();
};

export const clearAllCookies = () => {
  Object.keys(cookies.getAll()).map((cookie) => {
    deleteCookies(cookie);
  });
  return cookies.getAll();
};
